// SidebarAddClientGeneral component

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'
import validator from 'validator'

import countries from '../../../lib/countries.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import FieldTitle from '../../form/field_title/field_title.jsx'
import FieldText from '../../form/field_text/field_text.jsx'
import FieldSelect from '../../form/field_select/field_select.jsx'
import Input from '../../../common/form/input/input.jsx'
import Button from '../../common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class SidebarAddClientGeneral extends PureComponent {
  constructor (props) {
    super(props)
    this._references = {
      inputEmail: React.createRef()
    }

    this.state = {
      showError: false,
      isEditable: false
    }

    this.data = {
      languages: [
        { label: 'NL', value: 'NL' },
        { label: 'EN', value: 'EN' },
        { label: 'DE', value: 'DE' }
      ],
      countries: this._getCountryOptions()
    }
  }

  static get propTypes () {
    return {
      contact: PropTypes.object,
      isTeamUSA: PropTypes.bool,
      addressTypes: PropTypes.array,
      documentLanguages: PropTypes.array,
      onChange: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      contact: null,
      isTeamUSA: false,
      addressTypes: [],
      documentLanguages: [],
      onChange: null
    }
  }

  _getCountryOptions () {
    return countries.map(option => {
      return {
        label: IntlUtil.convertMessage(option.label),
        value: option.value
      }
    })
  }

  _getFilteredAddressTypes (includeType) {
    const { addressTypes, contact } = this.props
    if (contact.addresses.length > 0) {
      const existingTypes = contact.addresses.map(address => address.type)
      if (includeType) {
        _.remove(existingTypes, type => type === includeType)
      }
      return _.filter(
        addressTypes,
        typeInfo => existingTypes.indexOf(typeInfo.value) === -1
      )
    }

    return addressTypes
  }

  _canAddAddress () {
    const { addressTypes, contact } = this.props
    if (contact.addresses.length > 0) {
      const existingTypes = contact.addresses.map(address => address.type)
      if (_.uniq(existingTypes).length === addressTypes.length) {
        return false
      }
    }

    return true
  }

  render () {
    const { contact, isTeamUSA, documentLanguages } = this.props
    const {
      isErrorEmail,
      email,
      phone,
      mobile,
      website,
      documentLanguage
    } = contact

    const _className = classnames('panelform-col email-field', {
      hasError: isErrorEmail,
      showError: this.state.showError
    })

    return (
      <div className='sidebartab-general'>
        <div className='general-leftcol'>
          <div className='panelform-row information'>
            <div className='panelform-col information'>
              <FieldTitle title='projectV2.sidebarGeneral.information' />
            </div>
          </div>
          <div className='panelform-row'>
            <div className={_className}>
              <div className='client-email'>
                <FieldTitle title='projectV2.sidebarGeneral.email' />
                {this.state.showError && (
                  <span className='errorMsg'>
                    <IntlMessage ident='projectV2.sidebarGeneral.labelError' />
                  </span>
                )}
              </div>
              <FieldText
                ref={this._references.inputEmail}
                name='email'
                value={email}
                onChange={this._onChangeField.bind(this, 'email')}
                onBlur={this._onBlurField.bind(this, 'email', email)}
                validations={['email']}
              />
            </div>
          </div>
          <div className='panelform-row'>
            <div className='panelform-col'>
              <FieldTitle title='projectV2.sidebarGeneral.phone' />
              <FieldText
                name='phone'
                value={phone}
                onChange={this._onChangeField.bind(this, 'phone')}
              />
            </div>
          </div>
          <div className='panelform-row'>
            <div className='panelform-col'>
              <FieldTitle title='projectV2.sidebarGeneral.mobile' />
              <FieldText
                name='mobile'
                value={mobile}
                onChange={this._onChangeField.bind(this, 'mobile')}
              />
            </div>
          </div>
          <div className='panelform-row'>
            <div className='panelform-col'>
              <FieldTitle title='projectV2.sidebarGeneral.website' />
              <FieldText
                name='website'
                value={website}
                onChange={this._onChangeField.bind(this, 'website')}
              />
            </div>
          </div>
          <div className='panelform-row language'>
            <div className='panelform-col language'>
              <FieldTitle title='projectV2.sidebarGeneral.documentLanguage' />
              <FieldSelect
                name='documentLanguage'
                value={documentLanguage}
                options={documentLanguages}
                onChange={this._onChangeSelect.bind(this, 'documentLanguage')}
              />
            </div>
          </div>
        </div>
        <div className='sidebar-content-rightcol'>
          {!isTeamUSA && (
            <div className='panelform-row vat'>
              <div className='panelform-col vat'>
                <FieldTitle title='projectV2.sidebarGeneral.vat' />
              </div>
            </div>
          )}
          {!isTeamUSA && (
            <div className='panelform-row vatnumber'>
              <div className='panelform-col vatnumber'>
                <FieldTitle title='projectV2.sidebarGeneral.vatNumber' />
                <Input
                  type='text'
                  name='vatNo'
                  maxLength={100}
                  value={contact.vatNo}
                  size={10}
                  multilingual={false}
                  prefix={contact.country}
                  onChange={this._onChangeField.bind(this, 'vatNo')}
                  onFocus={this._onFocusField.bind(this, 'vatNo')}
                  onBlur={this._onBlurField.bind(this, 'vatNo')}
                  className={this.state.isEditable ? 'done' : ''}
                />
              </div>
            </div>
          )}
          <div className='panelform-row address'>
            <div
              className={
                isTeamUSA ? 'panelform-col addr' : 'panelform-col address'
              }
            >
              <FieldTitle title='projectV2.sidebarGeneral.address' />
            </div>
          </div>
          {this._renderAddresses()}
          {this._canAddAddress() && (
            <div className='panelform-row address-add'>
              <Button
                title='projectV2.sidebarGeneral.addNewAddress'
                className='add-button'
                onClick={this._onAddAddress} // eslint-disable-line react/jsx-handler-names
              />
            </div>
          )}
        </div>
      </div>
    )
  }

  _renderAddresses () {
    const { addresses } = this.props.contact

    return (
      <div className='address-list'>
        {addresses.map((address, index) => this._renderAddress(address, index))}
      </div>
    )
  }

  _renderAddress (address, addressIndex) {
    const { street, postcode, city, type, country } = address
    const addressTypes = this._getFilteredAddressTypes(address.type)

    return (
      <div key={`${addressIndex}`} className='address-item'>
        <div className='panelform-row type'>
          <div className='panelform-col type'>
            <FieldTitle title='projectV2.sidebarGeneral.type' />
            <div className='type-select'>
              <FieldSelect
                name='type'
                value={type}
                options={addressTypes}
                onChange={this._onChangeAddressSelect.bind(
                  this,
                  address,
                  'type'
                )}
              />
              <IconButton
                icon='x'
                size='small'
                type='secondary'
                className='cancel'
                canHover
                onClick={this._onDeleteAddress.bind(this, addressIndex)}
              />
            </div>
          </div>
        </div>
        <div className='panelform-row street'>
          <div className='panelform-col street'>
            <FieldTitle title='projectV2.sidebarGeneral.street' />
            <FieldText
              name='street'
              value={street}
              onChange={this._onChangeAddressField.bind(
                this,
                address,
                'street'
              )}
            />
          </div>
        </div>
        <div className='panelform-row details'>
          <div className='panelform-col zipcode'>
            <FieldTitle title='projectV2.sidebarGeneral.zipcode' />
            <FieldText
              name='postcode'
              value={postcode}
              onChange={this._onChangeAddressField.bind(
                this,
                address,
                'postcode'
              )}
            />
          </div>
          <div className='panelform-col city'>
            <FieldTitle title='projectV2.sidebarGeneral.city' />
            <FieldText
              name='city'
              value={city}
              onChange={this._onChangeAddressField.bind(this, address, 'city')}
            />
          </div>
        </div>
        <div className='panelform-col state'>
          <FieldTitle title='projectV2.sidebarGeneral.state' />
          <FieldSelect
            name='form-dropdown'
            value={country}
            options={this.data.countries}
            multilingual
            onChange={this._onChangeAddressSelect.bind(
              this,
              address,
              'country'
            )}
          />
        </div>
      </div>
    )
  }

  _onChangeField (name, value) {
    const { onChange } = this.props
    if (onChange) {
      onChange(name, value)
    }
  }

  _onFocusField (_name, _value) {
    this.setState({ isEditable: true })
  }

  _onBlurField (name, value) {
    if (name === 'email') {
      if (!validator.isEmail(value)) {
        this.setState({ showError: true, isEditable: false })
      } else {
        this.setState({ showError: false, isEditable: false })
      }
    } else {
      this.setState({ isEditable: false })
    }
  }

  _onChangeSelect (name, opt) {
    this._onChangeField(name, opt.value)
  }

  _onChangeAddressSelect (address, name, opt) {
    this._onChangeAddressField(address, name, opt.value)
  }

  _onChangeAddressField (address, name, value) {
    address[name] = value
    this._onChangeField('addresses', this.props.contact.addresses)
  }

  _onDeleteAddress = index => {
    const { addresses } = this.props.contact
    addresses.splice(index, 1)
    this._onChangeField('addresses', addresses)
  }

  _onAddAddress = () => {
    const { addresses } = this.props.contact
    addresses.push({
      type: '',
      street: '',
      postcode: '',
      streetNumber: '',
      city: '',
      state: '',
      country: 'NL'
    })
    this._onChangeField('addresses', addresses)
  }
}

export default SidebarAddClientGeneral
